export default __webpack_public_path__ + "static/media/cake_layer_two.9a2954e5.svg";